module.exports = "#frc-session .modal-title {\n  font-size: 24px;\n  padding-top: 10px;\n  color: #252528; }\n\n#frc-session .modal-body p {\n  font-size: 16px;\n  color: #919191; }\n\n#frc-session .modal-footer {\n  padding-bottom: 25px !important;\n  margin: 0px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/forcelogout-existingsession/forcelogout-existingsession.component.scss
// module id = ./src/app/forcelogout-existingsession/forcelogout-existingsession.component.scss
// module chunks = main